import React from 'react';

import { Slot } from './components/Slot/Slot';

function App() {
  return (
    <>
      <Slot />
    </>
  );
}

export default App;
